import React, { useState, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import { useParams } from "react-router-dom";
import Header from '../../Header';
import Footer from '../../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../../common/Config";
import {
	Box,
	TableContainer,
	TablePagination,
	Typography,
	Paper,
	TextField,
	InputAdornment,
	Grid2,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Tabs,
	Tab,
	Button,
	CircularProgress,
} from "@mui/material";
import { Iconify } from '../../Minimal/src/components/iconify/iconify';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { toast } from 'sonner';
import '../../common/commonStyles.css';

const TAB_KEYS = {
	SALES: 'sales',
	PURCHASE: 'purchase',
	PRICE: 'price',
	STOCK: 'stock',
};

const initialTabPagination = () => ({
	[TAB_KEYS.SALES]: { page: 0, rowsPerPage: 10, total: 0 },
	[TAB_KEYS.PURCHASE]: { page: 0, rowsPerPage: 10, total: 0 },
	[TAB_KEYS.PRICE]: { page: 0, rowsPerPage: 10, total: 0 },
	[TAB_KEYS.STOCK]: { page: 0, rowsPerPage: 10, total: 0 },
});

const srNoColumn = () => ({
	data: null,
	orderable: false,
	className: 'text-center',
	render(data, type, row, meta) {
		return meta.row + meta.settings._iDisplayStart + 1;
	},
});

const escapeHtml = (s) => {
	if (s == null || s === '') return '';
	return String(s)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
};

const formatStockOldQtysDisplay = (row) => {
	const legacy =
		row.old_qty ??
		row.oldQty ??
		row.previous_qty ??
		row.before_qty ??
		row.system_qty;
	const box = row.box_system_qty ?? row.old_box_qty;
	const piece = row.piece_system_qty ?? row.old_piece_qty;
	if (box == null && piece == null) {
		return legacy != null && legacy !== '' ? String(legacy) : '';
	}
	const b = box ?? '';
	const p = piece ?? '';
	return `Box: ${b} · Piece: ${p}`;
};

const formatStockNewQtysDisplay = (row) => {
	const legacy =
		row.new_qty ??
		row.newQty ??
		row.updated_qty ??
		row.after_qty ??
		row.balance_qty;
	const box = row.actual_box_balance ?? row.new_box_qty;
	const piece = row.actual_piece_balance ?? row.new_piece_qty;
	if (box == null && piece == null) {
		return legacy != null && legacy !== '' ? String(legacy) : '';
	}
	const b = box ?? '';
	const p = piece ?? '';
	return `Box: ${b} · Piece: ${p}`;
};

const pickStockTypeLabel = (row) =>
	row.type ||
	row.adjustment_type ||
	row.stock_type ||
	(row.order_type != null && row.order_type !== '' ? String(row.order_type) : '');

const pickPurchaseSupplier = (row) =>
	row.supplier ||
	row.supplier_name ||
	row.supplierName ||
	row.vendor_name ||
	row.company ||
	row.name ||
	'';

const pickPurchaseOrderNo = (row) =>
	row.order_no ||
	row.orderNo ||
	row.grn_no ||
	row.grnNo ||
	row.po_number ||
	row.po_no ||
	row.purchase_ref ||
	row.reference ||
	'';

const formatPurchaseTypeDisplay = (row) => {
	const raw = row.type ?? row.order_type ?? row.purchase_type ?? row.unit_type;
	if (raw === '' || raw == null) return '';
	if (raw === 1 || raw === '1') return 'Box';
	if (raw === 0 || raw === '0' || raw === 2 || raw === '2') return 'Piece';
	const str = String(raw).trim().toLowerCase();
	if (str === 'box' || str === 'piece') return str.charAt(0).toUpperCase() + str.slice(1);
	return String(raw);
};

const pickPurchaseUnitCost = (row) =>
	row.net_unit_cost ??
	row.unit_cost ??
	row.piece_cost ??
	row.unit_price ??
	row.unitPrice ??
	'';

const detachDataTablesWrapper = ($table) => {
	const $w = $table.closest('.dataTables_wrapper');
	if (!$w.length) return;
	$w.before($table.detach());
	$w.remove();
};

const pickProductTitleFromSalesResponse = (json) => {
	if (!json) return '';
	const rootName =
		json.product_name ??
		json.productName ??
		json.name ??
		json.product?.product_name ??
		json.product?.name;
	const rootCode =
		json.product_code ?? json.productCode ?? json.product?.product_code ?? json.product?.code;
	const row0 = Array.isArray(json.data) && json.data.length > 0 ? json.data[0] : null;
	const name =
		(rootName != null && String(rootName).trim() !== '' ? String(rootName).trim() : null) ??
		(row0?.product_name ?? row0?.productName ?? row0?.name ?? '');
	const code =
		(rootCode != null && String(rootCode).trim() !== '' ? String(rootCode).trim() : null) ??
		(row0?.product_code ?? row0?.code ?? '');
	const n = String(name || '').trim();
	const c = String(code || '').trim();
	if (n && c) return `${n}(${c})`;
	return n || c || '';
};

const renderSalesOrderNoLink = (row, type) => {
	const text = row.order_no || row.orderNo || row.invoice_no || row.invoice_number || '';
	if (type !== 'display') return text;
	const linkId = row.sale_id ?? row.saleId ?? row.order_id ?? row.orderId;
	if (!text || linkId == null || linkId === '') return escapeHtml(String(text));
	const id = encodeURIComponent(String(linkId));
	const href =
		row.status === 'Accept'
			? `${config.BASE_URL}/new_sales/invoice/${id}`
			: `${config.BASE_URL}/trip_summary/print/${id}`;
	return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color:#212b36;text-decoration:underline">${escapeHtml(String(text))}</a>`;
};

const renderPurchaseOrderLink = (row, type) => {
	const text = pickPurchaseOrderNo(row);
	const id = row.grn_id ?? row.grnId;
	if (type !== 'display') return text;
	const hasId = id !== undefined && id !== null && String(id).trim() !== '';
	if (!hasId) return escapeHtml(String(text || ''));
	const href = `${config.BASE_URL}/purchases/view_grn/${encodeURIComponent(String(id))}`;
	const label = text || String(id);
	return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color:#212b36;text-decoration:underline">${escapeHtml(String(label))}</a>`;
};

const PDF_TAB_TITLES = {
	[TAB_KEYS.SALES]: 'Sales History',
	[TAB_KEYS.PURCHASE]: 'Purchase History',
	[TAB_KEYS.PRICE]: 'Price History',
	[TAB_KEYS.STOCK]: 'Stock Adjustment History',
};

const getPdfHeaders = (tab) => {
	switch (tab) {
		case TAB_KEYS.SALES:
			return ['Sr. No', 'Date', 'Customer Name', 'Order No', 'Qty', 'Type', 'Unit Price'];
		case TAB_KEYS.PURCHASE:
			return ['Sr. No', 'Date', 'Supplier Name', 'GRN No', 'Qty', 'Type', 'Unit Cost'];
		case TAB_KEYS.PRICE:
			return ['Changed Date', 'Product Name', 'Old Price', 'New Price', 'Changed By'];
		case TAB_KEYS.STOCK:
			return ['Sr. No', 'Date', 'Old Qty (Box / Piece)', 'New Qty (Box / Piece)', 'Type', 'Change By'];
		default:
			return [];
	}
};

const buildPdfDataRow = (tab, row, idx) => {
	const s = (v) => (v == null || v === '' ? '' : String(v));
	switch (tab) {
		case TAB_KEYS.SALES:
			return [
				String(idx + 1),
				s(row.date || row.addedOn_date || row.sale_date || row.invoice_date),
				s(row.customer_name || row.customerName || row.cust_name || row.name),
				s(row.order_no || row.orderNo || row.invoice_no || row.invoice_number),
				s(row.qty ?? row.quantity),
				s(row.type || row.order_type || row.sale_type || row.unit_type),
				s(row.unit_price ?? row.unitPrice),
			];
		case TAB_KEYS.PURCHASE:
			return [
				String(idx + 1),
				s(row.date || row.addedOn_date || row.purchase_date || row.grn_date),
				s(pickPurchaseSupplier(row)),
				s(pickPurchaseOrderNo(row)),
				s(row.qty ?? row.quantity),
				s(formatPurchaseTypeDisplay(row)),
				s(pickPurchaseUnitCost(row)),
			];
		case TAB_KEYS.PRICE:
			return [
				s(row.addedOn_date),
				s(row.name),
				s(row.old_price),
				s(row.new_price),
				s(row.username),
			];
		case TAB_KEYS.STOCK:
			return [
				String(idx + 1),
				s(row.date || row.addedOn_date || row.adjustment_date || row.created_at),
				s(formatStockOldQtysDisplay(row)),
				s(formatStockNewQtysDisplay(row)),
				s(pickStockTypeLabel(row)),
				s(
					row.username ||
						row.change_by ||
						row.changed_by ||
						row.user_name ||
						row.changedBy
				),
			];
		default:
			return [];
	}
};

const PreviousProduct = () => {
	const { productId } = useParams();
	const tableRef = useRef(null);
	const [searchValue, setSearchValue] = useState('');
	const accessToken = localStorage.getItem('accessToken');
	const [activeTab, setActiveTab] = useState(TAB_KEYS.SALES);
	const [tabPagination, setTabPagination] = useState(initialTabPagination);
	const [productName, setProductName] = useState('');
	const [pdfExporting, setPdfExporting] = useState(false);
	const [excelExporting, setExcelExporting] = useState(false);

	useEffect(() => {
		if (!accessToken || !productId) return undefined;
		const fd = new FormData();
		fd.append('draw', '1');
		fd.append('start', '0');
		fd.append('length', '1');
		fd.append('searchValue', '');
		fd.append('id', productId);
		let cancelled = false;
		fetch(`${config.API_URL}/product_previous_sales`, {
			method: 'POST',
			headers: { authorization: `Bearer ${accessToken}` },
			body: fd,
		})
			.then((r) => r.json())
			.then((json) => {
				if (cancelled || !json) return;
				const label = pickProductTitleFromSalesResponse(json);
				if (label) setProductName(label);
			})
			.catch(() => {});
		return () => {
			cancelled = true;
		};
	}, [accessToken, productId]);

	const activePagination = tabPagination[activeTab];
	const rowsPerPageForActiveTab = tabPagination[activeTab].rowsPerPage;

	const tableConfigs = useMemo(() => ({
		[TAB_KEYS.SALES]: {
			url: `${config.API_URL}/product_previous_sales`,
			columns: [
				srNoColumn(),
				{
					data: 'date',
					defaultContent: '',
					render: (d, t, row) => row.date || row.addedOn_date || row.sale_date || row.invoice_date || '',
				},
				{
					data: 'customer_name',
					defaultContent: '',
					render: (d, t, row) => row.customer_name || row.customerName || row.cust_name || row.name || '',
				},
				{
					data: 'order_no',
					defaultContent: '',
					render: (d, t, row) => renderSalesOrderNoLink(row, t),
				},
				{ data: 'qty', defaultContent: '', render: (d, t, row) => row.qty ?? row.quantity ?? '' },
				{
					data: 'type',
					defaultContent: '',
					render: (d, t, row) =>
						row.type || row.order_type || row.sale_type || row.unit_type || '',
				},
				{
					data: 'unit_price',
					defaultContent: '',
					render: (d, t, row) =>
						row.unit_price || row.unitPrice || row.unit_price || row.unitPrice || '',
				},
			],
		},
		[TAB_KEYS.PURCHASE]: {
			url: `${config.API_URL}/product_previous_purchases`,
			columns: [
				srNoColumn(),
				{
					data: 'date',
					defaultContent: '',
					render: (d, t, row) => row.date || row.addedOn_date || row.purchase_date || row.grn_date || '',
				},
				{
					data: 'supplier_name',
					defaultContent: '',
					render: (d, t, row) => pickPurchaseSupplier(row),
				},
				{
					data: 'order_no',
					defaultContent: '',
					render: (d, t, row) => renderPurchaseOrderLink(row, t),
				},
				{ data: 'qty', defaultContent: '', render: (d, t, row) => row.qty ?? row.quantity ?? '' },
				{
					data: 'type',
					defaultContent: '',
					render: (d, t, row) => formatPurchaseTypeDisplay(row),
				},
				{
					data: 'unit_price',
					defaultContent: '',
					render: (d, t, row) => pickPurchaseUnitCost(row),
				},
			],
		},
		[TAB_KEYS.PRICE]: {
			url: `${config.API_URL}/product_previous_pricing`,
			columns: [
				{ data: 'addedOn_date', className: 'col-date', defaultContent: '' },
				{ data: 'name', className: 'col-name', defaultContent: '' },
				{ data: 'old_price', className: 'col-old-price', defaultContent: '' },
				{ data: 'new_price', className: 'col-new-price', defaultContent: '' },
				{ data: 'username', className: 'col-changed-by', defaultContent: '' },
			],
		},
		[TAB_KEYS.STOCK]: {
			url: `${config.API_URL}/product_previous_stock_adjustment`,
			columns: [
				srNoColumn(),
				{
					data: 'date',
					defaultContent: '',
					render: (d, t, row) => row.date || row.addedOn_date || row.adjustment_date || row.created_at || '',
				},
				{
					data: 'old_qty',
					defaultContent: '',
					render: (d, t, row) => formatStockOldQtysDisplay(row),
				},
				{
					data: 'new_qty',
					defaultContent: '',
					render: (d, t, row) => formatStockNewQtysDisplay(row),
				},
				{
					data: 'type',
					defaultContent: '',
					render: (d, t, row) => pickStockTypeLabel(row),
				},
				{
					data: 'username',
					defaultContent: '',
					render: (d, t, row) =>
						row.username ||
						row.change_by ||
						row.changed_by ||
						row.user_name ||
						row.changedBy ||
						'',
				},
			],
		},
	}), []);

	useLayoutEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return undefined;
		}
		if (!accessToken || !productId) return undefined;

		const el = tableRef.current;
		if (!el) return undefined;

		const $table = $(el);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}
		detachDataTablesWrapper($table);
		$table.find('tbody').empty();

		const cfg = tableConfigs[activeTab];
		if (!cfg) return undefined;

		const tabKey = activeTab;

		$table.DataTable({
			processing: true,
			serverSide: true,
			paging: true,
			dom: 'rt',
			pageLength: rowsPerPageForActiveTab,
			ajax: {
				url: cfg.url,
				type: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				data(d) {
					const sv = searchValue || '';
					const baseSearch =
						d && typeof d.search === 'object' && d.search !== null ? d.search : {};
					return $.extend({}, d, {
						draw: d.draw,
						start: d.start,
						length: d.length,
						searchValue: sv,
						id: productId,
						search: { ...baseSearch, value: sv },
					});
				},
				dataSrc(json) {
					if (json && json.recordsFiltered !== undefined) {
						setTabPagination((prev) => ({
							...prev,
							[tabKey]: { ...prev[tabKey], total: json.recordsFiltered },
						}));
					}
					if (tabKey === TAB_KEYS.SALES && json) {
						const label = pickProductTitleFromSalesResponse(json);
						if (label) setProductName(label);
					}
					return json.data || [];
				},
			},
			columns: cfg.columns,
			columnDefs: [{ orderable: false, targets: '_all' }],
			createdRow(row) {
				row.classList.add('previous-price-body-row');
			},
			drawCallback() {
				const api = this.api();
				setTabPagination((prev) => ({
					...prev,
					[tabKey]: {
						...prev[tabKey],
						page: api.page(),
						rowsPerPage: api.page.len(),
					},
				}));
			},
		});

		return () => {
			if ($table.length && $.fn.DataTable.isDataTable($table)) {
				$table.DataTable().destroy();
			}
			detachDataTablesWrapper($table);
			$table.find('tbody').empty();
		};
	}, [accessToken, productId, activeTab, searchValue, rowsPerPageForActiveTab, tableConfigs]);

	const handleTabChange = (_e, newTab) => {
		if (newTab === activeTab) return;
		const el = tableRef.current;
		if (el) {
			const $t = $(el);
			if ($.fn.DataTable.isDataTable($t)) {
				$t.DataTable().destroy();
			}
			detachDataTablesWrapper($t);
			$t.find('tbody').empty();
		}
		setActiveTab(newTab);
	};

	const fetchActiveTabExportRows = async () => {
		const cfg = tableConfigs[activeTab];
		if (!cfg?.url) {
			throw new Error('No data source');
		}
		const fd = new FormData();
		fd.append('draw', '1');
		fd.append('start', '0');
		fd.append('length', '10000');
		fd.append('searchValue', searchValue || '');
		fd.append('search[value]', searchValue || '');
		fd.append('id', productId);
		const res = await fetch(cfg.url, {
			method: 'POST',
			headers: { authorization: `Bearer ${accessToken}` },
			body: fd,
		});
		const json = await res.json();
		if (!res.ok) {
			throw new Error(json?.message || 'Request failed');
		}
		const rows = Array.isArray(json.data) ? json.data : [];
		if (rows.length === 0) {
			throw new Error('NO_DATA');
		}
		return rows;
	};

	const handleExportPdf = async () => {
		if (!accessToken || !productId) {
			toast.error('Missing session or product');
			return;
		}
		setPdfExporting(true);
		try {
			const rows = await fetchActiveTabExportRows();
			const headers = getPdfHeaders(activeTab);
			const body = rows.map((row, i) => buildPdfDataRow(activeTab, row, i));
			const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
			const title = `Product History${productName ? ` : ${productName}` : ''}`;
			doc.setFontSize(11);
			doc.text(title, 40, 32);
			doc.setFontSize(9);
			doc.setTextColor(99, 115, 129);
			doc.text(PDF_TAB_TITLES[activeTab] || '', 40, 48);
			doc.setTextColor(33, 43, 54);
			doc.autoTable({
				head: [headers],
				body,
				startY: 56,
				styles: { fontSize: 7, cellPadding: 4, overflow: 'linebreak' },
				headStyles: { fillColor: [33, 43, 54], textColor: 255, fontStyle: 'bold' },
				margin: { left: 40, right: 40 },
				horizontalPageBreak: true,
			});
			const slug = (PDF_TAB_TITLES[activeTab] || 'export').replace(/\s+/g, '_');
			doc.save(`${slug}_${productId}_${new Date().toISOString().slice(0, 10)}.pdf`);
			toast.success('PDF exported');
		} catch (err) {
			if (err?.message === 'NO_DATA') {
				toast.error('No data to export');
			} else {
				toast.error('Failed to export PDF');
			}
		} finally {
			setPdfExporting(false);
		}
	};

	const handleExportExcel = async () => {
		if (!accessToken || !productId) {
			toast.error('Missing session or product');
			return;
		}
		setExcelExporting(true);
		try {
			const rows = await fetchActiveTabExportRows();
			const headers = getPdfHeaders(activeTab);
			const sheetRows = rows.map((row, i) => {
				const values = buildPdfDataRow(activeTab, row, i);
				return headers.reduce((acc, header, colIndex) => {
					acc[header] = values[colIndex] ?? '';
					return acc;
				}, {});
			});
			const ws = XLSX.utils.json_to_sheet(sheetRows);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, PDF_TAB_TITLES[activeTab] || 'Export');
			const slug = (PDF_TAB_TITLES[activeTab] || 'export').replace(/\s+/g, '_');
			XLSX.writeFile(wb, `${slug}_${productId}_${new Date().toISOString().slice(0, 10)}.xlsx`);
			toast.success('Excel exported');
		} catch (err) {
			if (err?.message === 'NO_DATA') {
				toast.error('No data to export');
			} else {
				toast.error('Failed to export Excel');
			}
		} finally {
			setExcelExporting(false);
		}
	};

	const handleChangePage = (_event, newPage) => {
		const $table = $(tableRef.current);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().page(newPage).draw('page');
			setTabPagination((prev) => ({
				...prev,
				[activeTab]: { ...prev[activeTab], page: newPage },
			}));
		}
	};

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		const $table = $(tableRef.current);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().page.len(newRowsPerPage).draw();
			setTabPagination((prev) => ({
				...prev,
				[activeTab]: {
					...prev[activeTab],
					rowsPerPage: newRowsPerPage,
					page: 0,
				},
			}));
		}
	};

	const renderTableHead = () => {
		if (activeTab === TAB_KEYS.SALES) {
			return (
				<TableRow className="table-cell-header">
					<TableCell width="56px" align="center">Sr. No</TableCell>
					<TableCell width="100px">Date</TableCell>
					<TableCell width="400px">Customer Name</TableCell>
					<TableCell width="100px">Order No</TableCell>
					<TableCell width="100px">Qty</TableCell>
					<TableCell width="100px">Type</TableCell>
					<TableCell width="100px">Unit Price</TableCell>
				</TableRow>
			);
		}
		if (activeTab === TAB_KEYS.PURCHASE) {
			return (
				<TableRow className="table-cell-header">
					<TableCell width="56px" align="center">Sr. No</TableCell>
					<TableCell>Date</TableCell>
					<TableCell>Supplier Name</TableCell>
					<TableCell>GRN No</TableCell>
					<TableCell>Qty</TableCell>
					<TableCell>Type</TableCell>
					<TableCell>Unit Cost</TableCell>
				</TableRow>
			);
		}
		if (activeTab === TAB_KEYS.PRICE) {
			return (
				<TableRow className="table-cell-header">
					<TableCell width="100px">Changed Date</TableCell>
					<TableCell width="200px">Product Name</TableCell>
					<TableCell width="120px">Old Price</TableCell>
					<TableCell width="120px">New Price</TableCell>
					<TableCell width="150px">Changed By</TableCell>
				</TableRow>
			);
		}
		return (
			<TableRow className="table-cell-header">
				<TableCell width="56px" align="center">Sr. No</TableCell>
				<TableCell>Date</TableCell>
				<TableCell>Old Qty (Box / Piece)</TableCell>
				<TableCell>New Qty (Box / Piece)</TableCell>
				<TableCell>Type</TableCell>
				<TableCell>Change By</TableCell>
			</TableRow>
		);
	};

	return (
		<>
			<Box className="page-container">
				<Paper className="paper-style">
					<Box sx={{ px: 2, py: 1.2 }}>
						<Grid2 container spacing={2} display="flex" justifyContent="space-between" alignItems="center">
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Typography variant="h5" sx={{ fontWeight: 600, color: '#212b36' }}>
									Product History{productName ? ` : ${productName}` : ''}
								</Typography>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 6 }}>
								<Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
									<TextField
										className="input-border"
										label="Search"
										variant="outlined"
										size="small"
										value={searchValue}
										onChange={(e) => setSearchValue(e.target.value)}
										InputProps={{
											startAdornment: (
												<InputAdornment position="start">
													<Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
												</InputAdornment>
											),
										}}
										sx={{ minWidth: 250 }}
									/>
									<Button
										className="button-variant-contained"
										variant="contained"
										size="small"
										onClick={handleExportPdf}
										disabled={pdfExporting || excelExporting || !productId}
										startIcon={
											pdfExporting ? (
												<CircularProgress color="inherit" size={16} />
											) : (
												<Iconify icon="mdi:file-pdf-box" width={20} height={20} />
											)
										}
									>
										Export PDF
									</Button>
									<Button
										className="button-variant-contained"
										variant="contained"
										size="small"
										onClick={handleExportExcel}
										disabled={excelExporting || pdfExporting || !productId}
										startIcon={
											excelExporting ? (
												<CircularProgress color="inherit" size={16} />
											) : (
												<Iconify icon="mdi:file-excel" width={20} height={20} />
											)
										}
									>
										Export Excel
									</Button>
								</Box>
							</Grid2>
						</Grid2>
						<Box sx={{ borderBottom: 1, borderColor: 'divider', mt:1}}>
							<Tabs className="common-tabs" value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
								<Tab label="Sales History" value={TAB_KEYS.SALES} />
								<Tab label="Purchase History" value={TAB_KEYS.PURCHASE} />
								<Tab label="Price History" value={TAB_KEYS.PRICE} />
								<Tab label="Stock Adjustment History" value={TAB_KEYS.STOCK} />
							</Tabs>
						</Box>
					</Box>

					<TableContainer>
						<Table className="table-cell-border previous-price-table" ref={tableRef}>
							<TableHead>
								{renderTableHead()}
							</TableHead>
							<TableBody />
						</Table>
					</TableContainer>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<TablePagination
							component="div"
							count={activePagination.total}
							page={activePagination.page}
							onPageChange={handleChangePage}
							rowsPerPage={activePagination.rowsPerPage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							rowsPerPageOptions={[10, 25, 50, 100]}
							className="pagination-styles"
						/>
					</Box>
				</Paper>
			</Box>
		</>
	);
};

export default PreviousProduct;
